module.exports = __webpack_public_path__ + "img/sub_icon3.799d3b9e.svg";